<template>
    <div class="download-section">
        <span class="download-title">{{l10nDownload}}:</span>
        <a class="download-option" :class="audioObj.class" :href="audioObj.href" target="_blank" download @click="onClick">
            <font-awesome-icon class="download-section-icon" :icon="['fal', 'headphones']"/>
        </a>
        <a class="download-option"
           :class="videoObj.class" :href="videoObj.href" target="_blank" @click="onClick">
            <font-awesome-icon class="download-section-icon" :icon="['fal', 'video']"/>
        </a>
        <a class="download-option last-download-option" :class="pdfObj.class" :href="pdfObj.href" target="_blank"
           download @click="onClick">
            <font-awesome-icon class="download-section-icon" :icon="['fal', 'print']"/>
        </a>
    </div>
</template>

<script>

    import helpers from '../../services/helpers'
    import {
        GET_LOGGED_IN,
        SET_SIGNUP_SHOW_STATE,
    } from '../../services/constants'

    export default {
        name: 'jabra-download-section',
        props: {
            lesson: {
                type: Object,
                default: () => {
                    return {
                        audio: null,
                        video: null,
                        pdf: null,
                    }
                }
            }
        },
        computed: {
            isUserAuthenticated() {
                return this.$store.getters[GET_LOGGED_IN]
            },
            l10nDownload() {
                return this.l10nGetter('download')
            },
            typeCheckPassing() {
                return this.lesson && this.lesson.audio && this.lesson.video && this.lesson.pdf
            },
            audioObj() {
                return {
                    class: {
                        'not-option': this.lesson.audio === null
                    },
                    href: this.isUserAuthenticated && this.typeCheckPassing ? this.mapToRelativeUrl(this.lesson.audio.url) : false,
                }
            },
            videoObj() {
                return {
                    class: {
                        'not-option': this.lesson.video === null
                    },
                    href: this.isUserAuthenticated && this.typeCheckPassing ? this.lesson.video.url : false,
                }
            },
            pdfObj() {
                return {
                    class: {
                        'not-option': this.lesson.pdf === null
                    },
                    href: this.isUserAuthenticated && this.typeCheckPassing ? this.mapToRelativeUrl(this.lesson.pdf.url) : false,
                }
            },
        },
        methods: {
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
            mapToRelativeUrl(absoluteUrl) {
                return absoluteUrl.replace('https://jabrutouch-cms-media.s3.amazonaws.com/', '/s3/')
            },
            onClick() {
                if (this.isUserAuthenticated) {
                    return
                }
                this.$store.commit(SET_SIGNUP_SHOW_STATE, true)
            },
        }
    }
</script>

<style scoped lang="scss">

    @import "../../scss/main";

    .download-section {
        display: flex;
        align-items: center;
    }

    .download-title {
        @include font-abraham(16px, $grey-1, 400);
        margin: 0 16px 0 0;
    }

    .download-option {
        cursor: pointer;
        text-decoration: none;

        &.not-option {
            cursor: not-allowed;
            @include font-abraham(14px, #c0c0c0, 100);
        }

        display: flex;
        align-items: center;
        @include font-abraham(14px, $grey-1, 100);
        margin: 0 21px 0 0;

        &.last-download-option {
            margin: 0;
        }
    }

    .download-section-icon {
        font-size: 24px;
        margin: 0 6px 0 0;
    }


</style>
